import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { StorageService } from "../services/storage.service";
import { AuthService } from "src/app/services/auth.service";
import { MyZpaxService } from "src/app/services/myzpax.service";
import { appRoute } from "src/app/app-route.constants";
import { captureReauthState } from "src/app/common/utils/myzpax-routes.util";

export const userValidatedGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const sessionStorage = inject(StorageService);
  const myzpaxService = inject(MyZpaxService);
  const router = inject(Router);

  const goReauth = () => {
    if (myzpaxService.isInMyzpax) {
      return router.createUrlTree([`/${appRoute.init}`], { queryParams: { state: captureReauthState() } });
    }
    authService.redirectToSSOLoginPage();
    return false;
  };

  if (sessionStorage.getUser() !== null) {
    const user = JSON.parse(sessionStorage.getUser()!);
    if (user?.npi) {
      return goReauth();
    }
    return true;
  } else {
    return goReauth();
  }
};
